function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.924,
  cy: 4.25,
  rx: 4.237,
  ry: 4.25,
  fill: "#00969F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.938 7.792C13.83 7.792 10.5 11.913 10.5 17h14.875c0-5.086-3.33-9.209-7.438-9.209z",
  fill: "#00969F"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.177,
  cy: 7.25,
  rx: 3.24,
  ry: 3.25,
  fill: "#00969F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.188 9.959C27.046 9.959 24.5 13.11 24.5 17h11.375c0-3.889-2.546-7.041-5.688-7.041z",
  fill: "#00969F"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.677,
  cy: 7.25,
  rx: 3.24,
  ry: 3.25,
  fill: "#00969F"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.688 9.959C2.546 9.959 0 13.11 0 17h11.375c0-3.889-2.546-7.041-5.688-7.041z",
  fill: "#00969F"
});

function SvgStudentsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 17,
    viewBox: "0 0 36 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsActive);
export default __webpack_public_path__ + "static/media/students_active.b8a480f0.svg";
export { ForwardRef as ReactComponent };